export default function Hero() {
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'radial-gradient(circle at center, #1A1A2E 0%, #16213E 100%)',
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      
      {/* Floating particles */}
      <div className="absolute top-20 left-20 w-3 h-3 rounded-full bg-blue-500 opacity-60 animate-pulse"></div>
      <div className="absolute top-40 right-32 w-2 h-2 rounded-full bg-blue-400 opacity-50 animate-pulse" style={{ animationDelay: '0.5s' }}></div>
      <div className="absolute bottom-40 left-40 w-3 h-3 rounded-full bg-blue-500 opacity-40 animate-pulse" style={{ animationDelay: '1s' }}></div>
      <div className="absolute top-60 right-60 w-2 h-2 rounded-full bg-blue-300 opacity-60 animate-pulse" style={{ animationDelay: '1.5s' }}></div>
      <div className="absolute bottom-60 right-40 w-3 h-3 rounded-full bg-blue-500 opacity-50 animate-pulse" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-8 lg:px-24 flex items-center justify-between">
        {/* Left side - Text content */}
        <div className="w-full lg:w-5/12 space-y-6">
          <div className="space-y-2">
            <h1 className="text-7xl lg:text-8xl font-bold text-white leading-none tracking-tight">
              Modern
            </h1>
            <h1 className="text-7xl lg:text-8xl font-bold text-white leading-none tracking-tight ml-8">
              Applications
            </h1>
            <h1 className="text-7xl lg:text-8xl font-bold text-white leading-none tracking-tight ml-16">
              For iOS
            </h1>
          </div>
          <p className="text-lg text-gray-300 max-w-lg ml-4">
            Expert team developing innovative iOS solutions that enhance user experience and mobile device security
          </p>
        </div>

        {/* Right side - iPhone mockup */}
        <div className="hidden lg:block w-7/12 relative">
          <div className="relative" style={{ transform: 'rotate(15deg)' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/147fb327c1824d6071777a64b66a894a.jpg"
              alt="iOS Application"
              className="w-full h-auto object-contain"
              style={{
                filter: 'drop-shadow(0 40px 80px rgba(0, 0, 0, 0.3))',
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}